<div class="bet-radar-iframe-scroll">
    @if (betRadarUrl) {
        <iframe class="bet-radar-iframe" [src]="betRadarUrl"></iframe>
    }
</div>
